<template>
    <div>
        <div class="section-heading" v-if="section.name || section.description">
            <div class="intro-headline" v-if="section.name">
                <h2>{{section.name}}</h2>
            </div>
            <div class="intro-text" v-html="section.description" v-if="section.description"></div>
        </div>
        <product-sub-section
                v-for="(sub_section, index) in sub_sections"
                :key="sub_section"
                :index="index"
                :section="section.name"
                :sub_section="sub_section"
                :products="sortProductsBySubSection(products, sub_section)"
        ></product-sub-section>
    </div>
</template>

<script>
    import ProductSubSection from "./ProductSubSection.vue";

    export default {
        props: ['section','sub_sections','products'],

        components: {
            ProductSubSection
        },

        methods: {
            sortProductsBySubSection(productsToShow, sub_section){
                return productsToShow.filter(product => {
                    if(typeof product.show_in_sub_sections != 'undefined' && product.show_in_sub_sections.includes(sub_section)){
                        return product;
                    }
                });
            }
        }
    }
</script>

<style>

</style>